import {ButtonView, ClassicEditor, FileRepository} from "ckeditor5";
import {CONFIG} from "../../common/EditorConfig";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import React, {useContext, useRef, useState} from "react";
import {uploadTemplateFile} from "../../common/api/WebApi";
import {AppContext} from "../../../lib/AppContext";
import MDButton from "../../../components/MDButton";

export default function PortalBrander({data, header, footer, onSave}) {
  const [context, setContext] = useContext(AppContext);

  const [portalData, setPortalData] = useState(data);
  const [editing, setEditing] = useState(false);

  const editorRef = useRef(null);

  const handleChange = (e, editor) => {
    setPortalData(editor.getData());
  }

  const [blurEditor, setBlurEditor] = useState();

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {

          const body = new FormData();
          loader.file.then((file) => {
            const fileType = file.type;
            const fileName = file.name;
            const reader = new FileReader();

            reader.onload = function (evt) {
              let fileRequest = {
                imageType: fileType,
                imageName: fileName,
                data: btoa(evt.target.result)
              }

              uploadTemplateFile(fileRequest).then(result => {
                if (result.error) {
                  setContext({...context, error: {message: result.message}});
                } else {
                  loader.uploaded = true;
                  loader.uploadUrl = result;
                }
                resolve({
                  default: result.fileLocation
                })
              });
            }
            reader.readAsBinaryString(file);
          });
        })
      }
    }
  }

  const insertText = (text) => {
    blurEditor.model.change(writer => {
      writer.insertText(text + " ", blurEditor.model.document.selection.getFirstPosition());
    });
  };

  const handleBlur = (event, editor) => {
    setBlurEditor(editor);
  };

  function uploadPlugin(editor) {
    editor.plugins.get(FileRepository).createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  function previewPlugin(editor) {
    editor.ui.componentFactory.add('preview', (locale) => {
      const view = new ButtonView(locale);

      view.set({
        label: 'Preview',
        tooltip: true,
        withText: true
      });

      view.on('execute', () => {
        const data = editor.getData();
        setPreview(data);
        setShowPreview(true);
        return;
        const previewWindow = window.open('', '_blank');
        previewWindow.document.write(data);
        previewWindow.document.close();
      });

      return view;
    });
  }

  const [preview, setPreview] = useState();
  const [showPreview, setShowPreview] = useState(false);

  return (
    <>
      {!editing && <>
        <div
          dangerouslySetInnerHTML={{__html: data || '<p>None yet</p>'}}/>

        <MDButton color="primary"
                  size="small"
                  className="pull-right"
                  onClick={() => {
                    setEditing(true);
                  }}>Edit</MDButton>
      </>}

      {editing && <div className={'psb-carded p-3'}>

        <div className={'cls clearfix'}>&nbsp;</div>
        <CKEditor
          editor={ClassicEditor}
          config={{
            htmlSupport: {
              allow: [
                {
                  name: /.*/,
                  attributes: true,
                  classes: true,
                  styles: true
                }
              ]
            },
            placeholder: 'Enter ' + (header ? 'Header' : 'Footer') + ' HTML',
            toolbar: CONFIG.TOOLBAR,
            plugins: CONFIG.PLUGINS,
            extraPlugins: [
              uploadPlugin,
              previewPlugin
            ]
          }}
          data={portalData || ''}
          onReady={editor => {
            editorRef.current = editor;
          }}
          onChange={(event, editor) => {
            handleChange(event, editor);
          }}
          onBlur={(event, editor) => {
            handleBlur(event, editor);
          }}
          onFocus={(event, editor) => {
          }}
        />

        <MDButton color="info"
                  size="small"
                  className="pull-left my-2"
                  onClick={() => {
                    setEditing(false);
                  }}>Cancel</MDButton>

        <MDButton color="secondary"
                  size="small"
                  className="pull-right my-2"
                  onClick={() => {
                    const data = editorRef.current.getData();

                    const cleaned = data
                      .replace(/^<p>/i, '<div>')
                      .replace(/<\/p>$/i, '</div>');

                    onSave(cleaned);
                  }}>Save</MDButton>
        <div className={'cls clearfix'}>&nbsp;</div>
      </div>
      }

    </>
  )
}